import { TableHeaderConfigWithType } from '../../components/_EOS/Table/types'
import { StockMovement } from './Entities/StockMovement'
import { fechaFormateada, formatExpirationDate } from '../../utils/dateHelper'

export const generateTableHeadersStockMovement = () => {
  const tableHeaders: TableHeaderConfigWithType<StockMovement>[] = [
    {
      field: 'movementDate',
      title: 'Fecha',
      sortable: true,
      style: { whiteSpace: 'nowrap' },
      formater: (value) =>
        fechaFormateada(value as string, 'dd-MM-yyyy HH:mm:ss')
    },
    {
      field: 'pickingRouteId',
      title: 'Ruta',
      sortable: false
    },
    {
      field: 'asnId',
      title: 'ASN ID',
      sortable: false,
      formater: (value) => (value ? value.toString() : 'N/A')
    },
    {
      field: 'workOrderId',
      title: 'OT',
      sortable: false,
      formater: (value) => (value ? value.toString() : 'N/A')
    },
    {
      field: 'sku',
      title: 'SKU',
      sortable: false
    },
    {
      field: 'position',
      title: 'Nombre Posición',
      sortable: false
    },
    {
      field: 'typeMovement',
      title: 'Tipo Movimiento',
      sortable: false
    },
    {
      field: 'quantity',
      title: 'Cantidad',
      sortable: false
    },
    {
      field: 'batchNumber',
      title: 'Lote/Fecha Vencimiento',
      sortable: false,
      formater: batchNumberFormater
    },
    {
      field: 'user',
      title: 'Usuario',
      sortable: false
    }
  ]

  return tableHeaders
}

const batchNumberFormater = (
  _value: string | number | boolean | Date | null | undefined,
  item?: StockMovement | undefined
) => {
  const batch = item?.batch || item?.batchNumber
  const expirationDate = item?.expirationDate

  if (batch && expirationDate) {
    return batch
  }

  if (batch) {
    return batch
  }

  if (expirationDate) {
    return formatExpirationDate(expirationDate.toString(), 'dd-MM-yyyy')
  }

  return 'Sin Lote'
}
